import * as files from './services/FileService';
import * as applications from './services/ApplicationService';
import loadForm from "./form-helper";

// Live image upload
function imageData() {
    return {
        imageUrl: '',

        fileChosen(event) {
            this.fileToDataUrl(event, src => this.imageUrl = src)
        },

        fileToDataUrl(event, callback) {
            if (!event.target.files.length) return

            let file = event.target.files[0],
                reader = new FileReader()

            reader.readAsDataURL(file)
            reader.onload = e => callback(e.target.result)
        },

        fileDelete() {
            this.imageUrl = '';
            document.querySelector('[data-role=avatar-upload]').value = '';
        }
    }
}

window.imageData = imageData;

// init file elements
document.querySelectorAll('.file-upload input[type="file"]')
    .forEach(file => {
        file.isImage = file.accept.match(/image/) ? true : false;
        file.nameQueuedFile = file.name.substring(1);

        file.addEventListener('change', event => {

            if (!files.validateUploadedItems(event, file.isImage)) {
                return;
            }

            let upload = event.target.files[0];
            files.progress(100, file);

            let elFilename = file.parentNode.querySelector('[data-role="filename"]');
            if (elFilename) {
                elFilename.innerHTML = upload.name;
            }

            let elFilesize = file.parentNode.querySelector('[data-role="filesize"]');
            if (elFilesize) {
                elFilesize.innerHTML = parseInt(upload.size / 1024) + 'Kb';
            }
        });

        ['drop', 'dragover', 'dragdrop', 'dragenter', 'dragleave'].forEach(eventName => {
            file.parentNode.addEventListener(eventName, event => {
                event.preventDefault();
                event.stopPropagation();
            });
        })

        file.parentNode.addEventListener('dragover', event => {
            file.parentNode.querySelector('[data-svg="default"]').classList.add('hidden');
            file.parentNode.querySelector('[data-svg="forbidden"]').classList.add('hidden');

            if (files.validateUploadedItems(event, file.isImage)) {
                file.parentNode.querySelector('[data-svg="default"]').classList.remove('hidden');

                if (!file.isImage) {
                    file.parentNode.classList.add('border-secondary', 'bg-secondary-5');
                }
            } else {
                file.parentNode.querySelector('[data-svg="forbidden"]').classList.remove('hidden');

                if (!file.isImage) {
                    file.parentNode.classList.add('border-semantic-error', 'bg-semantic-error-light');
                }
            }

            if (file.isImage) {
                file.parentNode.querySelector('[data-role="progress"]').classList.remove('opacity-0', 'bg-semantic-error');
                file.parentNode.querySelector('[data-role="progress"]').classList.add('opacity-75', 'bg-primary-20');
            } else {
                file.parentNode.classList.remove('border-primary-20');
            }
        });

        file.parentNode.addEventListener('dragleave', event => {
            files.resetDragDropClasses(file.parentNode);
        });

        file.parentNode.addEventListener('drop', event => {
            files.resetDragDropClasses(file.parentNode);

            if (files.validateUploadedItems(event, file.isImage)) {
                file.files = event.dataTransfer.files;
                file.dispatchEvent(new Event('change'));
            }
        });

        let elCancel = file.parentNode.querySelector('[data-role="cancel"]');
        let elDelete = file.parentNode.querySelector('[data-role="delete"]');

        if (elCancel) {
            elCancel.addEventListener('click', event => {
                // cancel the upload ?
                if (file.source) {
                    file.source.cancel();
                }

                // call the delete event ?
                if (elDelete) {
                    elDelete.dispatchEvent(new Event('click'));
                }
            });
        }

        if (elDelete) {
            elDelete.addEventListener('click', event => {
                // hide progress output
                file.parentNode.querySelector('[data-role="progress"]').classList.add('hidden');

                // clear field value
                let field = document.querySelector('[name="' + file.nameQueuedFile + '"]');

                if (field) {
                    field.value = '';
                }

                // reset image
                let bgCoverEl = file.parentNode.querySelector('.bg-cover')
                let bgCoverSvgEl = file.parentNode.querySelector('.bg-cover svg')

                if (bgCoverEl) {
                    bgCoverEl.style.backgroundImage = 'none';
                }
                if (bgCoverSvgEl) {
                    bgCoverSvgEl.style.display = 'block';
                }
            });
        }
    });

loadForm('application', async (data, form) => {
    if (!data.attributes.disclaimer) {
        document.getElementById('form-submit').disabled = false;
        document.getElementById('form-submit').classList.remove('opacity-50');
        applications.setFormErrors('disclaimer', 'required');

        let el = document.querySelector('[data-role="errors-feedback"]');
        if (el) {
            el.classList.remove('hidden');
        }
        return;
    }

    // Before submitting to the back-end we'll first have to loop through all the inputs fields
    // Upload the files of these inputs fields, then continue with the submission
    let promises = [];
    let failedUploadingFiles = false;

    document.querySelectorAll('.file-upload input[type="file"]')
        .forEach(input => {
            const dataValue = input.name.substring(1);
            const file = input.files[0];

            if (!file) return;

            let data = new FormData();
            data.append('file', file);
            data.append('type', input.accept.match(/image/) ? 'image' : 'document');

            promises.push(
                files.upload(data).then(resp => ({key: dataValue, value: resp.id}))
                    .catch(e => {
                        failedUploadingFiles = true;
                        const errorResponse = e.response?.data?.errors?.file?.[0] || e.response?.data?.message;

                        document.getElementById('form-submit').disabled = false;
                        document.getElementById('form-submit').classList.remove('opacity-50');
                        applications.setFormErrors(dataValue, [errorResponse]);

                        let el = document.querySelector('[data-role="errors-feedback"]');
                        if (el) {
                            el.classList.remove('hidden');
                        }
                    })
            )
        });

    let uploadedFiles = await Promise.all(promises).catch(() => {});

    if (failedUploadingFiles)
        return;

    if (uploadedFiles) {
        uploadedFiles.forEach(file => data.attributes[file.key] = file.value);
    }

    // Continue with the submission

    let queryParams = Object.assign(
        {},
        ...window.location.search.substring(1)
            .split('&')
            .filter(parameter => !!parameter)
            .map(parameter => {
                parameter = parameter.split('=');
                return {[parameter[0]]: parameter[1]}
            })
    );

    let params = 'previewHash' in queryParams ? {previewHash: queryParams.previewHash} : {};

    data.attributes.referrer = getCookie('jobtoolz-referrer');
    data.attributes.job_channel_id = getCookie('jobtoolz-job-channel');
    data.attributes.campaign_id = getCookie('jobtoolz-campaign');
    data.attributes.campaign_source = getCookie("jobtoolz-campaign-source");

    applications.store({data: data}, params)
        .then(resp => {
            location.href = Jobtoolz.urls.success + window.location.search;
        })
        .catch(resp => {
            if (resp.response.status === 404) {
                let el = document.querySelector('[data-role="errors-404"]');
                if (el) {
                    el.classList.remove('hidden');
                }
            } else if (
                (typeof (resp.response) != 'undefined') &&
                (typeof (resp.response.data) != 'undefined') &&
                (typeof (resp.response.data.errors) != 'undefined')
            ) {
                for (let field in resp.response.data.errors) {
                    applications.setFormErrors(field, resp.response.data.errors[field]);
                }

                let el = document.querySelector('[data-role="errors-feedback"]');
                if (el) {
                    el.classList.remove('hidden');
                }

                // reset submit button
                document.getElementById('form-submit').disabled = false;
                document.getElementById('form-submit').classList.remove('opacity-50');
            }
        })
}, () => {
    applications.resetFormErrors();
});

// init education/experience
['education', 'experience'].forEach(field => applications.setDynamicFields(field));

// init disclaimer
let disclaimerButton = document.querySelector('[data-action="disclaimer"]');
if (disclaimerButton) {
    disclaimerButton.addEventListener('click', function () {
        window.dispatchEvent(new Event('open-policy'))
    });
}

// set flatpickr
applications.setFlatpickr();
